import styled from "styled-components";
import { Color, Device, Font } from "@styles/constants";
import { SmallBodyMediumCSS } from "@styles/typography";

export const Container = styled.div`
  padding: 30px 0;
  border-top: 1px solid ${Color.blackBrand};

  @media ${Device.mediumUp} {
    padding: 40px 0;
  }

  h4 {
    ${SmallBodyMediumCSS}
    text-align: left;
    margin-bottom: 17px;
  }

  ul {
    display: flex;
    flex-wrap: nowrap;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    font-family: ${Font.semibold};
    padding: 6px 20px;
    background: ${Color.blueAsh};
    text-transform: uppercase;

    + li {
      margin-left: 10px;
    }
  }
`;
